import React from 'react';
import { Card, List, Spin } from 'antd';
import PropTypes from 'prop-types';

const AssetInfo = ({ asset }) => {
  if (asset === null) {
    return (
      <Card title="Loading...">
        <Spin />
      </Card>
    );
  }
  return (
    <Card title={asset.name}>
      <h3>{asset.description}</h3>
      <p>
        <strong>Asset ID: </strong>
        {asset.id}
      </p>
      <p>
        <strong>Parent Asset ID: </strong>
        {asset.parentId}
      </p>
      <List
        itemLayout="horizontal"
        dataSource={Object.keys(asset.metadata)}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta title={item} description={asset.metadata[item]} />
          </List.Item>
        )}
      />
    </Card>
  );
};

AssetInfo.defaultProps = {
  asset: null,
};

AssetInfo.propTypes = {
  asset: PropTypes.shape({
    parentId: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    metadata: PropTypes.shape({}),
  }),
};

export default AssetInfo;



// WEBPACK FOOTER //
// ./src/components/AssetInfo/AssetInfo.js